import SendRestartPassword from './SendRestartPassword';

export default SendRestartPassword;